import React, { useRef, useCallback, useEffect } from "react";
import Navbar from "../components/Navbar";
import { openBooking } from "../utils/booking";
import Hero from "../components/Hero";
import ProblemSection from "../components/ProblemSection";
import ChallengeSection from "../components/ChallengeSection";
import ModelSection from "../components/ModelSection";
import WhySection from "../components/WhySection";
import TechDrivenSection from "../components/TechDrivenSection";
import ForWhomSection from "../components/ForWhomSection";
import CasesSection from "../components/CasesSection";
import AdditionalServicesSection from "../components/AdditionalServicesSection";
import FaqSection from "../components/FaqSection";
import CtaBanner from "../components/CtaBanner";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";
import Seo from "../components/Seo";
import { useLanguage } from "../context/LanguageContext";

const SEO_COPY = {
  es: {
    title: "Narwhal · Dirección de Negocios B2B as a Service",
    description:
      "Instalamos y ejecutamos una Dirección de Negocios B2B completa: desarrollo comercial, comunicación, SEO/AEO/GEO y paid media, bajo una sola dirección. Resultados reales en empresas reales.",
    keywords: "dirección de negocios B2B, desarrollo comercial B2B, SEO AEO GEO, go-to-market B2B, outbound, growth B2B",
  },
  en: {
    title: "Narwhal · B2B Business Leadership as a Service",
    description:
      "We install and run a complete B2B Business Leadership: commercial development, communication, SEO/AEO/GEO and paid media, under a single direction. Real results in real companies.",
    keywords: "B2B business development, commercial development, SEO AEO GEO, B2B go-to-market, outbound, B2B growth",
  },
};

const Home = () => {
  const { lang } = useLanguage();
  const seo = SEO_COPY[lang] || SEO_COPY.es;
  const contactRef = useRef(null);

  const scrollTo = useCallback((id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }, []);

  const scrollToContact = useCallback(() => openBooking(), []);
  const scrollToLayer = useCallback(() => scrollTo("servicios"), [scrollTo]);

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, []);

  return (
    <div className="relative">
      <Seo title={seo.title} description={seo.description} keywords={seo.keywords} />
      <Navbar onBook={scrollToContact} />
      <main>
        <Hero onBook={scrollToContact} onLayer={scrollToLayer} />
        <ChallengeSection />
        <ProblemSection />
        <ModelSection onBook={scrollToContact} />
        <WhySection />
        <TechDrivenSection />
        <ForWhomSection />
        <CasesSection />
        <AdditionalServicesSection />
        <FaqSection />
        <CtaBanner onBook={scrollToContact} />
        <ContactSection ref={contactRef} />
      </main>
      <Footer onBook={scrollToContact} />
      <WhatsAppFloat onClick={scrollToContact} />
    </div>
  );
};

export default Home;
